<script setup lang="ts">
import { ref, watchEffect } from "vue";
import confetti from "canvas-confetti";

const props = defineProps({
    visible: {
        type: Boolean,
        required: true,
    },
    successMessage: {
        type: String,
        default: "",
    },
    successIcon: {
        type: String,
        default: "pi-trophy",
    },
    textIcon: {
        type: String,
        default: "",
    },
    length: {
        type: Number,
        default: 3000,
    },
    popConfetti: {
        type: Boolean,
        default: true,
    },
});

const emits = defineEmits(["update:visible"]);

const display = ref(props.visible);

const triggerConfetti = () => {
    confetti({
        zIndex: 9999,
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
    });
};

const show = () => {
    display.value = true;
    if (props.popConfetti) {
        triggerConfetti();
    }
    setTimeout(() => {
        display.value = false;
        emits("update:visible", false);
    }, props.length);
};

watchEffect(() => {
    if (props.visible) {
        show();
    }
});
</script>

<template>
    <transition name="grow">
        <div v-if="display" id="success-icon_div_action-success" class="success-message">
            <i v-if="textIcon === ''" :class="'pi success-icon ' + successIcon"></i>
            <span v-else class="success-icon">{{ textIcon }}</span>
            <div v-if="successMessage !== ''" class="mt-4">{{ successMessage }}</div>
        </div>
    </transition>
</template>

<style scoped>
.success-message {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    background-color: var(--primary-color);
    border-radius: 50%;
    padding: 1rem;
    width: 200px;
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.success-icon {
    font-size: 5rem;
    color: white;
    z-index: 9999;
}

.success-message > div {
    color: white;
}
</style>
